import { apiAxios } from "./apiConfig";

export interface Role {
  id: string;
  name: string;
}

export interface UserDetails {
  id: string;
  email: string;
  is_active: boolean;
  role: Role;
  name: string;
}

export interface LoginResponse {
  status: boolean;
  data: {
    details: UserDetails;
    accessToken: string;
    refreshToken: string;
  };
}

export interface LoginPayload {
  email: string;
  password: string;
}

export const login = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response = await apiAxios.post<LoginResponse>("/admin/login", payload);

  return response.data;
};
